<template>
    <v-toolbar flat id="toolbar">
            <v-btn text :to="{ name: 'Request' }" color="secondary">
              <img src="@/assets/logo.png" class="logo">
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-items v-if="this.$store.state.auth">
                <div class="pt-2">
                  <v-btn icon :color="this.$route.name == 'Request' ? 'secondary' : 'info'" :to="{ name: 'Request' }">
                    <v-icon>mdi-text-box-multiple</v-icon>
                  </v-btn>
                  <v-btn icon :color="this.$route.name == 'Guarantee' ? 'secondary' : 'info'" :to="{ name: 'Guarantee' }" v-if="this.$store.state.auth.role === 'admin'">
                    <v-icon>mdi-shield</v-icon>
                  </v-btn>
                  <v-btn icon :color=" this.$route.name == 'User' ? 'secondary' : 'info'" :to="{ name: 'User' }" v-if="this.$store.state.auth.role === 'admin'">
                    <v-icon>mdi-account-group</v-icon>
                  </v-btn>
                </div>
                <div class="pt-4 pr-3 pl-3 account">
                  <div class="secondary--text">{{this.$store.state.auth.first_name}} {{this.$store.state.auth.last_name}}</div>
                  <small>{{this.$store.state.auth.email}}</small>
                </div>
                <v-btn class="mr-1 ml-1" v-on:click="logout" color="secondary" v-if="auth">Logout</v-btn>
            </v-toolbar-items>
        </v-toolbar>
</template>

<script>
    import firebase from "firebase";

    export default {
        name:'app-header',
        props: {
            auth: {
              type: Object,
              default: null
            },
        },
        methods: {
            logout: function() {
                firebase.auth().signOut().then(() => {
                  localStorage.removeItem('fcvbroker')
                  this.$store.commit('resetAuth')
                  this.$router.replace('/login')
                })
            }
        },
        data() {
            return {
                who: false,
                assurance: false,
                items: [
                  "test"
                ],
            }
        }
    }
</script>

<style lang="scss">
    #toolbar{
        a{
          text-decoration: none;
          &:before{
            opacity: 0;
          }
        }
        button{
            box-shadow: none !important;
            text-transform: initial !important;
        }
        select{
            padding: 6.5px 16px;
            border: 1px solid var(--v-secondary-base);
            font-size: 14px;
            border-radius: 4px;
            color: white;
            background: var(--v-secondary-base);
            margin-right: 8px;
            outline: none;
            text-align: center;
            text-align-last: center;
            -moz-text-align-last: center;
        }
        .logo{
            max-width: 100px;
            img{
                display: block;
                max-height: 100%;
            }
        }
        .account{
          line-height: 1rem;
        }
    }
</style>
